import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { DataService } from 'src/app/services/data.service';
import { HttpParams } from '@angular/common/http';
import { getJSON } from 'jquery';
import { Router } from '@angular/router';
import {MemoryStorageService} from 'src/app/services/memory-storage.service';

@Component({
  selector: 'app-qcrulebase',
  templateUrl: './qcrulebase.component.html',
  styleUrls: ['./qcrulebase.component.css']
})
export class QCRuleBaseComponent implements OnInit {

  lstQCData = [];
  lstDocumentType = [];
  lstQCExecution = [];
  lstFromProcess = [];
  lstToProcess = [];
  lstQCProcess = [];
  lstStatus = [];

  selectedDocumentType: any;
  selectedQCExecution: any;
  selectedFromProcess: any;
  selectedToProcess: any;
  selectedQCProcess: any;
  selectedStatus: any;

  ruleName: string = "";
  grpTabIndex: number = 0;
  lstColumnName = [];
  lstCompType = [];
  lstOperator = [];
  lstAllOperator = [];
  lstConnector = [];
  lstValue = [];
  qcViewColumnHide: any = ['QCRULE_ID', 'RULE_CONDITIONS', 'MOVETO_PROCESS_ID', 'MoveFrom_Process_Id', 'Document_Type_ID', 'QC_PROCESS_ID'];
  qcRuleColumnHide: any = ['columnId', 'compTypeId', 'operatorId', 'connectorId', 'valueId'];

  //lstConditionData: { Column: string, 'Comp Type': string, 'Operator': string, 'Value': string, 'Connector': string }[] = [];
  lstConditionData: any = [];
  selectedColumn: any;
  selectedCompType: any;
  selectedOperator: any;
  selectedConnector: any;
  selectedValue: any;
  strValue: any;
  strAdd: any;
  strSubmit: any;
  childGridUpdateIndex: number;
  qcRuleId: number = 0;
  valDropdown: boolean = false;

  constructor(private commonService: CommonService, private dataService: DataService, private router: Router,private memorystore: MemoryStorageService) {
    this.strAdd = 'Add';
    this.strSubmit = 'Save';
    this.childGridUpdateIndex = -1;
  }
  ngOnInit() {
    this.qcView();
    this.getInitialData();
  }

  getInitialData() {

    let initial_params = {
      "action": "GET_INITIAL_TYPE",
      "projectId": Number(this.commonService.selectedProject),
      "subgroupId": this.commonService.selectedSubgroup,
      "documentTypeId": 0,
      "moveFromProcessId": 0,
      "fieldName": ""
    };

    this.dataService.postData('getQCDetails', initial_params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res.data != null) {
          this.lstDocumentType = [];
          for (var i = 0; i < res.data.Table.length; i++) {
            this.lstDocumentType.push({
              docTypeId: res.data.Table[i].Id,
              docTypeName: res.data.Table[i].Name
            });
          }
          this.selectedDocumentType = this.lstDocumentType.length > 0 ? 0 : '';
          this.onSelectDocumentType(this.selectedDocumentType, 0, 0);
          //pre post
          this.lstQCExecution = [];
          for (var i = 0; i < res.data.Table1.length; i++) {
            this.lstQCExecution.push({
              qcExecutionId: res.data.Table1[i].Id,
              qcExecutionName: res.data.Table1[i].Name
            });
          }
          this.selectedQCExecution = this.lstQCExecution.length > 0 ? 'Pre' : '';
          //Quality Check
          this.lstQCProcess = [];
          for (var i = 0; i < res.data.Table2.length; i++) {
            this.lstQCProcess.push({
              qcProcessId: res.data.Table2[i].Id,
              qcProcessName: res.data.Table2[i].Name
            });
          }
          this.selectedQCProcess = this.lstQCProcess.length > 0 ? 0 : '';
          //Status
          this.lstStatus = [];
          this.lstStatus.push({ statusId: '0', statusName: '--Select--' });
          this.lstStatus.push({ statusId: 'ACTIVE', statusName: 'Active' });
          this.lstStatus.push({ statusId: 'INACTIVE', statusName: 'Inactive' });
          this.selectedStatus = this.lstStatus.length > 0 ? 'ACTIVE' : '';
          //connector
          this.lstConnector = [];
          this.lstConnector.push({ connectorId: '0', connectorName: '--Select--' });
          this.lstConnector.push({ connectorId: 'AND', connectorName: 'AND' });
          this.lstConnector.push({ connectorId: 'OR', connectorName: 'OR' });
          this.selectedConnector = this.lstConnector.length > 0 ? '0' : '';
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });
  }


  //doctypechange
  onSelectDocumentType(docId, fromPId: number, toPId: number) {

    let initial_params = {
      "action": "GET_PROCESS_AND_FIELD",
      "projectId": Number(this.commonService.selectedProject),
      "subgroupId": this.commonService.selectedSubgroup,
      "documentTypeId": Number(docId),
      "moveFromProcessId": 0,
      "fieldName": ""
    };
    this.dataService.postData('getQCDetails', initial_params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res.data != null) {
          this.lstFromProcess = [];
          for (var i = 0; i < res.data.Table.length; i++) {
            this.lstFromProcess.push({
              fromProcessId: res.data.Table[i].Id,
              fromProcessName: res.data.Table[i].Name
            });
          }
          this.selectedFromProcess = this.lstFromProcess.length > 0 ? fromPId : '';
          this.onSelectFromProcess(this.selectedFromProcess, toPId);

          this.lstColumnName = [];
          for (var i = 0; i < res.data.Table1.length; i++) {
            this.lstColumnName.push({
              columnId: res.data.Table1[i].Id,
              columnName: res.data.Table1[i].Name
            });
          }
          this.selectedColumn = this.lstColumnName.length > 0 ? '0' : '';
          this.onSelectColumn(this.selectedColumn, '0', '0', '');
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });

  }


  //from process change event
  onSelectFromProcess(processId, toProId) {

    let initial_params = {
      "action": "GET_TO_PROCESS",
      "projectId": Number(this.commonService.selectedProject),
      "subgroupId": this.commonService.selectedSubgroup,
      "documentTypeId": Number(this.selectedDocumentType),
      "moveFromProcessId": Number(processId),
      "fieldName": ""
    };

    this.dataService.postData('getQCDetails', initial_params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res.data != null) {
          this.lstToProcess = [];
          for (var i = 0; i < res.data.Table.length; i++) {
            this.lstToProcess.push({
              toProcessId: res.data.Table[i].Id,
              toProcessname: res.data.Table[i].Name
            });
          }
          this.selectedToProcess = this.lstToProcess.length > 0 ? toProId : '';
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });

  }


  onSelectColumn(columnId: string, compId: string, optrId: string, value: string) {


    //let objColName = this.lstColumnName.find(el => el.columnId == columnId);
    //if(this.selectedFromProcess)

    let initial_params = {
      "action": "GET_BY_FIELD",
      "projectId": Number(this.commonService.selectedProject),
      "subgroupId": this.commonService.selectedSubgroup,
      "documentTypeId": Number(this.selectedDocumentType),
      "moveFromProcessId": Number(this.selectedFromProcess),
      "fieldName": columnId
    };

    this.dataService.postData('getQCDetails', initial_params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res.data != null) {
          this.lstCompType = [];
          for (var i = 0; i < res.data.Table.length; i++) {
            this.lstCompType.push({
              compTypeId: res.data.Table[i].Id,
              compTypeName: res.data.Table[i].Name
            });
          }

          this.selectedCompType = this.lstCompType.length > 0 ? compId == '0' ? this.lstCompType[0].compTypeId : compId : '';


          this.lstOperator = [];
          for (var i = 0; i < res.data.Table1.length; i++) {
            this.lstOperator.push({
              operatorId: res.data.Table1[i].Id,
              operatorName: res.data.Table1[i].Name
            });
          }
          this.selectedOperator = this.lstOperator.length > 0 ? optrId : '';

          //value
          this.lstValue = [];
          for (var i = 0; i < res.data.Table2.length; i++) {
            this.lstValue.push({
              valueId: res.data.Table2[i].Id,
              valueName: res.data.Table2[i].Name
            });
          }

          if (this.lstValue.length > 1) {
            this.valDropdown = true;

            this.selectedValue = this.lstValue.length > 0 ? value == '' ? 0 : value : '';
          }
          else {
            this.valDropdown = false;
            this.strValue = value;
          }

        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });


  }





  onAddClick() {

    let invalidSubmitMsg = '';

    let objColName = this.lstColumnName.find(el => el.columnId == this.selectedColumn);
    let objCompType = this.lstCompType.find(el => el.compTypeId == this.selectedCompType);
    let objOperatorName = this.lstOperator.find(el => el.operatorId == this.selectedOperator);
    let objconnectorName = this.lstConnector.find(el => el.connectorId == this.selectedConnector);
    let objValueName = this.lstValue.find(el => el.valueId == this.selectedValue);

    invalidSubmitMsg += typeof objColName !== "undefined" && objColName.columnName != '--Select--' ? '' : '-Please select Column.\r <br/>';
    invalidSubmitMsg += typeof objCompType !== "undefined" && objCompType.compTypeName != '--Select--' ? '' : '-Please select Comp Type.\r <br/>';
    invalidSubmitMsg += typeof objOperatorName !== "undefined" && objOperatorName.operatorName != '--Select--' ? '' : '-Please select Operator.\r <br/>';
    if (this.valDropdown == true) {
      invalidSubmitMsg += typeof objValueName !== "undefined" && objValueName.valueName != '--Select--' ? '' : '-Please select Value.\r <br/>';
    }
    else {
      invalidSubmitMsg += typeof this.strValue !== "undefined" && this.strValue != '' ? '' : '-Please enter Value.\r <br/>';
    }
    invalidSubmitMsg += typeof objconnectorName !== "undefined" && objconnectorName.connectorName != '--Select--' ? '' : '-Please select Connector.\r <br/>';


    if (invalidSubmitMsg != '') {
      this.commonService.showMessageBox(invalidSubmitMsg, 'Alert');

    }
    else {

      let obj = {
        Column: objColName.columnName,
        'Comp Type': objCompType.compTypeName,
        Operator: objOperatorName.operatorName,
        Value: this.valDropdown == true ? objValueName.valueName : this.strValue,
        Connector: objconnectorName.connectorName,
        Edit: "Edit",
        Delete: "Delete",
        columnId: objColName.columnId,
        compTypeId: objCompType.compTypeId,
        operatorId: objOperatorName.operatorId,
        connectorId: objconnectorName.connectorId,
        valueId: this.valDropdown == true ? objValueName.valueId : this.strValue
      }
      if (this.strAdd == 'Add') {
        this.lstConditionData.push(obj);
      }
      else if (this.strAdd == "Update" && this.childGridUpdateIndex != -1) {
        this.lstConditionData[this.childGridUpdateIndex] = obj;
        this.strAdd = 'Add';
        this.childGridUpdateIndex = -1;
      }
      this.clearChild();
    }

  }

  clearChild() {

    this.selectedColumn = this.lstColumnName.length > 0 ? '0' : '';
    this.onSelectColumn(this.selectedColumn, '0', '0', '0');
    this.strValue = ''
    this.selectedConnector = this.lstConnector.length > 0 ? "0" : "";
  }

  cellClickEvent(event) {


    if (event.columnName == "Edit") {
      this.selectedColumn = event.rowData['columnId'];
      this.onSelectColumn(event.rowData['columnId'], event.rowData['compTypeId'], event.rowData['operatorId'], event.rowData['valueId']);
      this.selectedConnector = event.rowData['connectorId'];
      this.strAdd = 'Update';
      this.childGridUpdateIndex = event.rowIndex;

    }
    else if (event.columnName == "Delete") {
      this.deleteMsg(event.rowIndex);
    }

  }

  deleteMsg(index: number) {
    if (index !== -1) {
      this.lstConditionData.splice(index, 1);
    }
  }


  onSaveClick() {

    let invalidSubmitMsg = '';

    let objDocumentType = this.lstDocumentType.find(el => el.docTypeId == this.selectedDocumentType);
    let objQCExecution = this.lstQCExecution.find(el => el.qcExecutionId == this.selectedQCExecution);
    let objFromProcess = this.lstFromProcess.find(el => el.fromProcessId == this.selectedFromProcess);
    let objToProcess = this.lstToProcess.find(el => el.toProcessId == this.selectedToProcess);
    let objQCProcess = this.lstQCProcess.find(el => el.qcProcessId == this.selectedQCProcess);
    let objStatus = this.lstStatus.find(el => el.statusId == this.selectedStatus);


    invalidSubmitMsg += typeof objDocumentType !== "undefined" && objDocumentType.docTypeId > 0 ? '' : '-Please select document type.\r <br/>';
    invalidSubmitMsg += typeof objQCExecution !== "undefined" && objQCExecution.qcExecutionId != 'PRE' ? '' : '-Please select QC Execution.\r <br/>';
    invalidSubmitMsg += (typeof objFromProcess !== "undefined" && objFromProcess.fromProcessId > 0 ? '' : (typeof objToProcess !== "undefined" && objToProcess.toProcessId > 0 ? '' : '-Please select From/To Process.\r <br/>'));
    invalidSubmitMsg += typeof objQCProcess !== "undefined" && objQCProcess.qcProcessId > 0 ? '' : '-Please select QC Process.\r <br/>';
    invalidSubmitMsg += typeof this.ruleName !== "undefined" && this.ruleName != '' ? '' : '-Please enter Rule Name.\r <br/>';
    invalidSubmitMsg += typeof objStatus !== "undefined" && objStatus.statusName != '--Select--' ? '' : '-Please select Status.\r <br/>';
    invalidSubmitMsg += typeof this.lstConditionData !== "undefined" && this.lstConditionData.length > 0 ? '' : '-Please add atleast one condition.\r <br/>';

    if (invalidSubmitMsg != '') {
      this.commonService.showMessageBox(invalidSubmitMsg, 'Alert');

    }
    else {

      let myClonedArray = Object.assign([], this.lstConditionData);
      let condition: any = [];

      for (let elm of myClonedArray) {
        let obj = {
          column: elm["Column"],
          comptype: elm["Comp Type"],
          compoperator: elm["Operator"],
          value: elm["Value"],
          connector: elm["Connector"],
          columnId: elm["columnId"],
          compTypeId: elm["compTypeId"],
          operatorId: elm["operatorId"],
          connectorId: elm["connectorId"],
          valueId: elm["valueId"]
        };
        condition.push(obj);
      }


      let json = JSON.stringify(condition);
      let action: string = 'Insert';


      if (this.strSubmit == "Update") {
        action = 'Update';
      }
      else {
        this.qcRuleId = 0;
      }


      let initial_params = {
        "ruleName": this.ruleName,
        "ruleCondition": json,
        "prepost": objQCExecution.qcExecutionName,
        "qcProcessId": objQCProcess.qcProcessId,
        "moveToProcessId": Number(objToProcess.toProcessId),
        "status": objStatus.statusId,
        "action": action,
        // "actionBy": this.commonService.getUserInfoFromLocalStorage('userId'),
        "actionBy": this.memorystore.getItem('userId'),
        "subgroupId": this.commonService.selectedSubgroup,
        "qcRuleId": this.qcRuleId,
        "documentTypeId": Number(objDocumentType.docTypeId),
        "moveFromProcessId": Number(objFromProcess.fromProcessId),
        "projectId": Number(this.commonService.selectedProject)
      };

      this.dataService.postData('postQCRule', initial_params).subscribe((res) => {
        if (res != null && (res.error_message == null || res.error_message == "")) {
          if (res.data != null) {
            if (res.data == 1) {
              this.commonService.showMessageBox("QC rule added successfully.", 'Alert');
              this.formReset();
              this.grpTabIndex = 0;
            }
            else if (res.data == 2) {
              this.commonService.showMessageBox("Rule Name already exists for selected document type.", 'Alert');
            }
            else if (res.data == 3 || res.data == 5) {
              this.commonService.showMessageBox("Rule already exists for selected queue movement.", 'Alert');
            }
            else if (res.data == 4) {
              this.commonService.showMessageBox("QC rule updated successfully.", 'Alert');
              this.formReset();
              this.grpTabIndex = 0;
            }
          }
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }
      },
        error => {
          if (error.includes("401")) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
        });
    }
  }

  onResetClick() {
    this.formReset();
  }



  formReset() {

    this.qcView();
    this.getInitialData();

    this.clearChild();
    if (this.lstConditionData.length > 0) {
      this.lstConditionData.splice(0, this.lstConditionData.length)
    }
    this.ruleName = "";
    this.strSubmit = "Save";
    this.qcRuleId = 0;
  }


  //QC VIEW

  // async qcView(): Promise<any> {
  //   let initial_params = {
  //     "action": "VIEW",
  //     "projectId": Number(this.commonService.selectedProject),
  //     "subgroupId": 0,
  //     "documentTypeId": 0,
  //     "moveFromProcessId": 0,
  //     "fieldName": ""
  //   };

  //   const result = await this.dataService.postData('getQCDetails', initial_params).toPromise();
  //   //this.lstQCData = result.data.Table;
  //   return result.data.Table;
  // }
  qcView() {

    let initial_params = {
      "action": "VIEW",
      "projectId": Number(this.commonService.selectedProject),
      "subgroupId": this.commonService.selectedSubgroup,
      "documentTypeId": 0,
      "moveFromProcessId": 0,
      "fieldName": ""
    };

    if (this.lstQCData.length > 0) {
      this.lstQCData.splice(0, this.lstQCData.length)
    }

    this.dataService.postData('getQCDetails', initial_params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res.data != null) {
          this.lstQCData = res.data.Table;
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });

  }



  cellClickEventQC(event) {
    if (event.columnName == "Edit") {

      this.selectedDocumentType = event.rowData['Document_Type_ID'];
      this.selectedQCExecution = event.rowData['QC Execution'];
      this.onSelectDocumentType(event.rowData['Document_Type_ID'], event.rowData['MoveFrom_Process_Id'], event.rowData['MOVETO_PROCESS_ID']);
      this.selectedQCProcess = event.rowData['QC_PROCESS_ID'];
      this.selectedStatus = event.rowData['Status'].toUpperCase();
      this.ruleName = event.rowData['Rule Name'];
      this.qcRuleId = Number(event.rowData['QCRULE_ID']);

      let myClonedArray = JSON.parse(event.rowData['RULE_CONDITIONS']);
      let condition: any = [];

      if (this.lstConditionData.length > 0) {
        this.lstConditionData.splice(0, this.lstConditionData.length)
      }

      for (let elm of myClonedArray) {


        let obj = {
          Column: elm["column"],
          'Comp Type': elm["comptype"],
          Operator: elm["compoperator"],
          Value: elm["value"],
          Connector: elm["connector"],
          Edit: "Edit",
          Delete: "Delete",
          columnId: elm["columnId"],
          compTypeId: elm["compTypeId"],
          operatorId: elm["operatorId"],
          connectorId: elm["connectorId"],
          valueId: elm["valueId"]
        }

        this.lstConditionData.push(obj);
      }
      this.strSubmit = 'Update';
      this.grpTabIndex = 1;
    }
    else if (event.columnName == "Delete") {


      this.deleteMsg(event.rowIndex);

      let initial_params = {
        "ruleName": '',
        "ruleCondition": '',
        "prepost": '',
        "qcProcessId": 0,
        "moveToProcessId": 0,
        "status": '',
        "action": "Delete",
        "actionBy": "",
        "subgroupId": this.commonService.selectedSubgroup,
        "qcRuleId": Number(event.rowData['QCRULE_ID']),
        "documentTypeId": 0,
        "moveFromProcessId": 0,
        "projectId": 0

      };


      this.dataService.postData('postQCRule', initial_params).subscribe((res) => {
        if (res != null && (res.error_message == null || res.error_message == "")) {
          if (res.data != null) {
            if (res.data == 6) {
              this.commonService.showMessageBox("QC Rule Deleted Successfully..", 'Alert');
              if (this.lstQCData.length > 0) {
                this.lstQCData.splice(0, this.lstQCData.length)
              }
              this.qcView();
            }
            else {
              this.commonService.showMessageBox("Error in delete.", 'Alert');
            }
          }
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }
      },
        error => {
          if (error.includes("401")) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
        });
    }
  }



}
